import React from 'react';
import { motion } from 'framer-motion';
const timelineData = [{
  day: 'Día 1-2',
  title: 'Mapeo de Tormentas',
  description: "Identificaremos tus 'disparadores silenciosos' antes de que se conviertan en tormentas incontrolables."
}, {
  day: 'Día 3-4',
  title: 'El Interruptor de Emergencia',
  description: 'Instalarás el Interruptor de 3 Segundos en tu rutina diaria (incluso en medio del caos total).'
}, {
  day: 'Día 5-6',
  title: 'Comunicación Magnética',
  description: 'Aprenderás guiones verbales que logran cooperación inmediata sin necesidad de alzar la voz.'
}, {
  day: 'Día 7',
  title: 'El Arte de Reparar',
  description: 'Sabrás exactamente cómo reparar el vínculo si cometes un error, eliminando la culpa tóxica para siempre.'
}];
export function TimelineSection() {
  return <section className="pt-24 pb-8 px-4 sm:px-6 lg:px-8 bg-cream-secondary" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-107">
          <h2 className="text-3xl sm:text-4xl font-bold font-heading text-text-dark mb-4" data-id="element-108">
            Lo que vas a lograr en 7 días
          </h2>
          <p className="text-lg text-text-medium" data-id="element-109">
            Un plan paso a paso, sin abrumarte.
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-110">
          {timelineData.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-cream p-6 sm:p-8 rounded-2xl shadow-sm border border-gold/10 flex flex-col sm:flex-row gap-6 items-start sm:items-center" data-id="element-111">
              <div className="flex-shrink-0 bg-gold/10 text-gold-dark font-heading font-bold text-xl px-6 py-3 rounded-xl border border-gold/20 min-w-[120px] text-center" data-id="element-112">
                {item.day}
              </div>
              <div data-id="element-113">
                <h3 className="text-xl font-bold text-text-dark mb-2 font-heading" data-id="element-114">
                  {item.title}
                </h3>
                <p className="text-text-medium leading-relaxed" data-id="element-115">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}